import {Core} from 'cytoscape';
import {OtherLinksMode, OtherNodesMode} from '@maporium-workspace/shared';

type ClassTarget = {
  addClass(classes: string): unknown;
  removeClass(classes: string): unknown;
};

const OTHER_CLASSES = 'hidden dimmed unlabeled';

export function otherLinksClassNames(mode: OtherLinksMode): string[] {
  if (mode === OtherLinksMode.HIDDEN) return ['hidden'];
  return mode === OtherLinksMode.DIMMED_UNLABELED ? ['dimmed', 'unlabeled'] : ['dimmed'];
}

export function applyOtherLinksClasses(elements: ClassTarget, mode: OtherLinksMode): void {
  elements.removeClass(OTHER_CLASSES);
  elements.addClass(otherLinksClassNames(mode).join(' '));
}

export function clearOtherClasses(elements: ClassTarget): void {
  elements.removeClass(OTHER_CLASSES);
}

/**
 * A node stands out when it is selected or attached to a link the current
 * linkage display leaves at full strength; everything else is "other".
 */
export function applyOtherNodesClasses(cy: Core, mode: OtherNodesMode): void {
  clearOtherClasses(cy.nodes());
  if (mode === OtherNodesMode.SHOWN) return;

  const prominentLinks = cy.edges().filter((edge) => !edge.hasClass('hidden') && !edge.hasClass('dimmed'));
  const standingOut = cy.nodes(':selected')
    .union(cy.edges(':selected').connectedNodes())
    .union(prominentLinks.connectedNodes());

  const others = cy.nodes().difference(standingOut);
  others.addClass('dimmed');
  if (mode === OtherNodesMode.DIMMED_UNLABELED) {
    others.addClass('unlabeled');
  }
}
